import { trackOnboardingAnalytics } from "@hooks/onboarding/onboardingAnalytics";
import {
  ONEPAGE_GUIDE_VARIANT,
  type OnepageGuideEndedOn,
  type OnepageGuideLandingTab,
} from "./onepageGuideTypes";

/**
 * 一屏引导埋点（fe-spec §3.5.1 / D20）。
 *
 * 事件名沿用 V3.0.4 `handoff_start` / `handoff_complete` / `handoff_skip`，补 `variant=onepage`
 * 区分口径；`handoff_beat_view` / `handoff_beat_advance` / `handoff_activate_tap` 随旧引导下线。
 *
 * 出口走 onboarding 统一门面 `trackOnboardingAnalytics`（GA 存量 `trackEvent` + OpenReplay
 * `Track.event` 双发，规范 §0）。三个都是 action 类，事件名无 `_view` 后缀。
 */

export function trackOnepageGuideStart(attrs: {
  has_goal: boolean;
  degraded: boolean;
  landing_tab: OnepageGuideLandingTab;
  reduced_motion: boolean;
}): void {
  trackOnboardingAnalytics("handoff_start", {
    ...attrs,
    variant: ONEPAGE_GUIDE_VARIANT,
  });
}

export function trackOnepageGuideComplete(endedOn: OnepageGuideEndedOn): void {
  trackOnboardingAnalytics("handoff_complete", {
    ended_on: endedOn,
    variant: ONEPAGE_GUIDE_VARIANT,
  });
}

export function trackOnepageGuideSkip(dwellMs: number): void {
  trackOnboardingAnalytics("handoff_skip", {
    variant: ONEPAGE_GUIDE_VARIANT,
    dwell_ms: Math.max(0, Math.round(dwellMs)),
  });
}
